import { graphql } from "@opensea/graphql"

export const readItemHighestTraitFloorFragment = graphql(`
  fragment readItemHighestTraitFloor on Item {
    __typename
    attributes {
      floorPrice {
        token {
          unit
          symbol
        }
      }
    }
  }
`)
